var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('use',_vm._b({attrs:{"href":'#' + _vm.name}},'use',{ 'xlink:href': '#' + _vm.name },false))])}
var staticRenderFns = []

export { render, staticRenderFns }